/*
 * <help-center> — category tabs for the contact-page FAQ.
 * Without JS every category panel is visible (no tablist). With JS: tabs (role=tablist) switch panels,
 * arrow keys / Home / End move between tabs.
 */
class HelpCenter extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-help-tab]')];
    this.panels = [...this.querySelectorAll('[data-help-panel]')];
    if (this.tabs.length < 2) return;
    this.setAttribute('data-enhanced', '');
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index, false));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
    this.select(0, false);
  }

  select(index, focus) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.select(next, true);
  }
}

if (!customElements.get('help-center')) customElements.define('help-center', HelpCenter);
